export const colorsTheme = {
  white: '#FFFFFF',
  black: '#000000',
  danger: '#F2383A',

  'gradient-deg': '90deg',
  'gradient-primary': '#003B30',
  'gradient-secondary': '#051514',

  'primary-color': '#003B30',
  'secondary-color': '#646464',
  'auxiliary-color': '#003B30',

  'secondary-button-background': 'transparent',
  'secondary-button-background-hover': '#003B30',
  'secondary-button-color': '#003B30',
  'secondary-button-color-hover': '#FFFFFF',
  'secondary-button-border': '#003B30',
  'secondary-button-border-hover': '#003B30',

  'bg-color': '#FFFFFF',
  'bg-secondary-color': '#121212',
  'bg-auxiliary-color': '#EDEDED',

  'bg-circle-color': '#FFFFFF',
  'bg-modal-color': '#FFFFFF',

  'filter-button-background': '#003B30',
  'filter-button-color': '#FFFFFF',
  'filter-button-border': '#003B30',
  'entry-message-color': '#003B30',

  'dark-color': '#3F3F3F',

  'text-primary': '#1E1E1E',
  'text-secondary': '#003B30;',
  'text-tertiary': '#FFFFFF;',
  'text-gray': '#4F4F4F',
  
  'input-color': '#1E1E1E',
  'bg-input-color': '#FFFFFF',
  'info-color': '#B6E3D6',
  'disabled-color': '#e2e2e2',
  'card-color': '#EEEEEE',
  'modal-border-color': '#ADB5BD',
  'border-color': '#003B30',
  'bg-login-color': '#003B30',
  'bg-login-page-color': '#003B30',

  'echeck-label-color': '#000',
  'echeck-border-color': '#D2D2D2',
  'echeck-text-color': '#000',
  'echeck-bar-color1': '#003B30',
  'echeck-bar-color2': '#003B30'
}